import { ApolloClient, InMemoryCache, createHttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { OPERATIONS_QUERY } from "graphql/operations";

// Bearer token is stored by auth flow in localStorage
const getBearerToken = () => {
  try {
    return localStorage.getItem("accessToken") || "";
  } catch {
    return "";
  }
};

// Apollo Client instance for operations service
let operationsClient = null;

/**
 * Initialize Apollo Client for operations service
 * @returns {ApolloClient} Configured Apollo Client instance
 */
const getOperationsClient = () => {
  if (operationsClient) {
    return operationsClient;
  }

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_DOORSHARP_GRAPHQL_ENDPOINT,
  });

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      "Content-Type": "application/json",
      ...(getBearerToken() ? { Authorization: `Bearer ${getBearerToken()}` } : {}),
    },
  }));

  operationsClient = new ApolloClient({
    link: from([authLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: "network-only",
        errorPolicy: "all",
      },
    },
  });

  return operationsClient;
};

export async function fetchOperations(timePeriod = "YTD", highlightsTimePeriod = "YTD", filters = {}) {
  try {
    const client = getOperationsClient();

    const { data } = await client.query({
      query: OPERATIONS_QUERY,
      variables: {
        timePeriod,
        highlightsTimePeriod,
        salesFilters: filters
      },
      fetchPolicy: "network-only",
    });

    console.log("Operations GraphQL response:", data);
    return data;
  } catch (error) {
    console.error("Operations GraphQL error:", error);
    throw error;
  }
}

